import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
	Button,
	useDataProvider,
	useNotify,
	useRecordContext,
	useRefresh,
} from "react-admin";
import type { AdminDataProvider } from "@/providers/dataProvider";

export const BanButton = () => {
	const record = useRecordContext();
	const dataProvider = useDataProvider<AdminDataProvider>();
	const refresh = useRefresh();
	const notify = useNotify();

	if (!record) return null;

	const handleBan = async () => {
		const reason = window.prompt("Enter ban reason (optional):");

		try {
			await dataProvider.ban(record.id, reason || undefined);
			notify("User banned successfully", { type: "success" });
			refresh();
		} catch (error) {
			notify(error instanceof Error ? error.message : "Failed to ban user", {
				type: "error",
			});
		}
	};

	const handleUnban = async () => {
		try {
			await dataProvider.unban(record.id);
			notify("User unbanned successfully", { type: "success" });
			refresh();
		} catch (error) {
			notify(error instanceof Error ? error.message : "Failed to unban user", {
				type: "error",
			});
		}
	};

	if (record.banned) {
		return (
			<Button
				label="Unban"
				onClick={handleUnban}
				startIcon={<CheckCircleIcon />}
				color="success"
			/>
		);
	}

	return (
		<Button
			label="Ban"
			onClick={handleBan}
			startIcon={<BlockIcon />}
			color="error"
		/>
	);
};
